import React from "react"

const WorksheetRowCollection = ({ children }) => <div>{children}</div>

WorksheetRowCollection.displayName = "WorksheetRowCollection"

WorksheetRowCollection.propTypes = {
  children: (props, propName, component) => {
    const prop = props[propName]
    let error
    React.Children.forEach(prop, child => {
      if (child.type.displayName !== "WorksheetRow") {
        error = new Error(
          `${component} requires WorksheetRow as its immediate children`
        )
      }
    })
    return error
  }
}

export default WorksheetRowCollection
